<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    persistent
    max-width="80%"
  >
    <v-card class="mx-auto pa-5">
      <base-material-card
        icon="mdi-account-multiple"
        title="ขอเพิ่มข้อมูลพนักงานราชการ"
        class="px-5 py-3 text_google"
      />

      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-container grid-list-md>
            <v-row>
              <!-- ฟอร์มกรอกข้อมูล -->
              <v-col cols="12" md="6">
                <!-- รหัสบัตรประชาชน -->
                <v-text-field
                  v-model="localData.personalIDcardReq"
                  outlined
                  prepend-icon="mdi-account-search"
                  label="รหัสบัตรประชาชน"
                  required
                  :rules="[v => !!v || 'กรุณากรอกรหัสบัตรประชาชน']"
                  @input="handleSearch"
                />

                <!-- เลือกตำแหน่ง -->
                <v-autocomplete
                  v-model="localData.collegeNewIdPosition"
                  :items="positions"
                  item-text="id_position"
                  item-value="id_position"
                  outlined
                  prepend-icon="mdi-account-search"
                  label="เลขที่ตำแหน่ง ณ สังกัดใหม่"
                  required
                  :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                  @change="handleSearch"
                >
                  <template v-slot:item="{ item }">
                    <div>
                      <div class="font-weight-bold">
                        {{ item.id_position }} : สำหรับ {{ item.positions }}
                      </div>
                      <div class="text-caption">คนครอง: {{ item.id_card }}</div>
                    </div>
                  </template>
                </v-autocomplete>

                <!-- วันที่ย้ายมา -->
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localData.collegePersonnelApp"
                      prepend-icon="mdi-calendar"
                      outlined
                      label="วันเดือนปีที่ย้ายมาปฏิบัติงาน"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                      :rules="[v => !!v || 'กรุณาเลือกวันที่']"
                    />
                  </template>
                  <v-date-picker
                    v-model="localData.collegePersonnelApp"
                    no-title
                    scrollable
                    locale="th"
                    @input="dateMenu = false"
                  />
                </v-menu>

                <!-- คำสั่งที่ -->
                <v-text-field
                  v-model="localData.collegePersonnelAppOrder"
                  outlined
                  prepend-icon="mdi-basket-fill"
                  label="คำสั่งให้ปฏิบัติงาน ที่"
                  required
                  :rules="[v => !!v || 'กรุณากรอกคำสั่ง']"
                />

                <!-- วันที่คำสั่ง -->
                <v-menu
                  v-model="orderDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localData.collegePersonnelAppOrderDate"
                      prepend-icon="mdi-calendar"
                      outlined
                      label="วันที่คำสั่ง"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                      :rules="[v => !!v || 'กรุณาเลือกวันที่คำสั่ง']"
                    />
                  </template>
                  <v-date-picker
                    v-model="localData.collegePersonnelAppOrderDate"
                    no-title
                    scrollable
                    locale="th"
                    @input="orderDateMenu = false"
                  />
                </v-menu>
              </v-col>

              <!-- แสดงข้อมูลพนักงานที่ค้นหา -->
              <v-col cols="12" md="6">
                <PersonnelInfoCard :personnel="personnelCheck" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="warning"
          large
          rounded
          @click="$emit('input', false)"
        >
          <v-icon left>mdi-close</v-icon>
          ยกเลิก
        </v-btn>
        <v-btn
          v-if="canSubmit"
          large
          color="success"
          rounded
          @click="handleSubmit"
        >
          <v-icon left>mdi-content-save</v-icon>
          บันทึกคำขอ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PersonnelInfoCard from "./PersonnelInfoCard.vue";

export default {
  name: "AddPersonnelDialog",
  
  components: {
    PersonnelInfoCard
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    personnelData: {
      type: Object,
      default: () => ({})
    },
    positions: {
      type: Array,
      default: () => []
    },
    personnelCheck: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      dateMenu: false,
      orderDateMenu: false
    };
  },

  computed: {
    localData: {
      get() {
        return this.personnelData;
      },
      set(value) {
        this.$emit("update:personnelData", value);
      }
    },

    canSubmit() {
      return (
        this.personnelCheck.id_position &&
        this.localData.collegePersonnelApp
      );
    }
  },

  methods: {
    handleSearch() {
      this.$emit("search");
    },

    handleSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("submit");
      }
    }
  }
};
</script>